import { event } from "@otto-ec/global-resources/event";
import { get } from "@otto-ec/global-resources/toggle";
import type { HTMLOcSheetV1Element } from "@otto-ec/otto-components/sheet";
import tracking from "../tracking/Tracking";

const RATINGS_SHEET_ID = "reptile-ratings-sheet";
const DETAILS_SHEET_ID = "reptile-ratings-detail-sheet";
const DELEGATOR_ELEMENT_ID = "reptile-content"; /*                                             */

function createSheet(id: string, headline: string, url: string): HTMLOcSheetV1Element {
  const sheet = document.createElement("oc-sheet-v1");
  sheet.id = id;
  sheet.open = false;
  sheet.headline = headline;
  sheet.url = url;

  return sheet;
}

export function registerRatingsSheet() {
  if (get("reptile_1283_enable_rating_opens_sheet", false)) {
    const infoSheet = createSheet(
      RATINGS_SHEET_ID,
      "So funktionieren unsere Kundenbewertungen",
      "/chameleon/crocotile/rating_sheet_text.html",
    );

    document.body.appendChild(infoSheet);

    const detailsSheet = createSheet(
      DETAILS_SHEET_ID,
      "Richtlinien für Bewertungen",
      "/chameleon/crocotile/rating_sheet_detail_text.html",
    );
    document.body.appendChild(detailsSheet);

    const delegationElement = document.getElementById(DELEGATOR_ELEMENT_ID);
    if (delegationElement !== null) {
      event.delegate(delegationElement, "click", ".reptile_js_open_sheet", () => {
        infoSheet.open = true;
        tracking.submitEvent({ san_ListLayer: "rating" });
      });
    }
  }
}

export type RatingSheetTrackingLabels = {
  san_ListLayer: "rating";
};
